// @flow
import { createSelector } from 'reselect'
import _map from 'lodash/map'
import { featureCollection } from '@turf/helpers'
// Selectors
import { operation$ } from 'hfty-soil-jobs-dom'
import featuresToGrid$ from './featuresToGrid'

export default (operation: object): object => createSelector(
  [
    featuresToGrid$,
    operation$,
  ],
  function (features: Array<Object>, operation: Object): object {
    if (features && features.length && operation) {
      const { grid } = operation.model.gridData

      let grids = _map(features, (feature: object): Array<Object> => {
        return {
          ...feature,
          properties: {
            ...feature.properties,
            isLocked: true,
            ...grid[feature.properties.featureIndex],
            units: grid.units,
          },
        }
      })

      return featureCollection(grids)
    }
    return null
  }
)
